module.exports = __webpack_public_path__ + "img/headphone.b56ee023.svg";